<template>
  <div>
    <div class="chairman-message">
      <div class="header">
        <img class="header-img" src="https://spkg.smartmice.cn/resources/images/official/about/4.jpg" />
        <div class="title">
          <div>董事长寄语</div>
          <img src="https://spkg.smartmice.cn/resources/images/official/common/downBtn.png">
        </div>
      </div>
      <div class="content">
        <p>
          20多年前，当我第一次接触会展旅游业务时，前辈告诉我它就是高端旅游。后来出国深造，才知道国际上统称MICE，即（Meeting, Incentive, Convention, Exhibition/Event）的简称，已存续超过了165年。再后来回国创业，先后创立了“运通会展”和“康辉会展”两个辉煌一时的品牌，有幸亲历了中国MICE产业的迅猛成长与壮大:
          <br>
          <br>
          我看到伴随中国经济腾飞，MICE从一个神秘的细分市场，以每年20%的增速，成为当下令人瞩目的万亿级市场；我看到从业者从懵懂寥寥，发展为现在万余家专业公司百舸争流；我看到曾经置若罔闻的媒体与资本，如今把MICE奉为新兴服务业的宠儿；我看到往昔不可一世的欧美同仁，看着中国成为全球最大MICE市场而唏嘘感叹……
          <br>
          <br>
          当然，我也清醒看到行业门槛不高，产品雷同，恶性价格竞争成为常态；看到从业者缺乏自律，急功近利，诚信合规底线被屡屡突破；看到因人才匮乏管理滞后，企业散乱弱小，市场渗透不足20%；看到服务过分依赖人力与经验，在一次次提心吊胆精疲力竭的付出后，依然得不到客户的认可与应得的价值……我曾无数次自问:什么时候，MICE服务可以更具技术含量，通过极致的客户体验，服务价值的提升，堂堂正正赢得体面的收入，赢得市场与客户的尊重！
          <br>
          <br>
          于是，伴随着理想，插上现代科技的翅膀，中智商展横空出世，与时俱进，创立了“智慧会展”全面构想： 2015年推出行业3.0（MICE+互联网），2018年宣布行业4.0（MICE+AI）的升级战略，努力用更智慧的方法为客户提供透明、节省、高效、智能的MICE商务场景服务。
          <br>
          <br>
        </p>
        <p>
          在资本支持下，中智商展顶住了不可名状的压力与质疑，克服了种种难以想象的困难，几年内完成了一次又一次自我颠覆式创新，高速奔跑在“智慧会展”的道路上。如今我们不仅新兴平台业务同比增幅高达179%，拥有了几十个软件著作权，步入全国高新、中关村高新技术企业行列，而且以人均高于传统模式几十倍的效率，与全球最大的医药、金融、保险、IT等客户形成了紧密的战略合作，两年内平台模式会议将突破100万场……
          <br>
          <br>
          几年时间，中智商展这支有理想、有能力、有魄力的创业团队走完了很多企业几十年未走完的发展之路，不仅以惊人的速度敲响了全国中小企业股转中心的宝钟，而且已经顺利毕业，成功退市，按计划向更高的目标前进。我们用自己的实际行动，坦荡而自豪的向行业、客户、市场、资本宣示了自己的理想，用产品赢得了尊重与价值。
          <br>
          <br>
          我们清醒意识到一切才刚刚开始，还有太多计划需要落地，也还会有太多挑战需要应对。中智商展不敢有丝毫懈怠，不忘初心，远瞻而务实，再接再厉，认真走好未来的每一步。智慧，让未来提前到来！
        </p>
        <img class="autograph" src="https://spkg.smartmice.cn/resources/images/official/about/message.jpg" />
      </div>     
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from '@/components/Footer'
export default {
    name: 'ChairmanMessage',
    components: {
      Footer
    }
}
</script>
<style lang="less" scoped>
@media (min-width: 997px) {
  .content {
    overflow: hidden;
    zoom: 1;
    padding: 80px;
  }
  p {
    width: 50%;
    float: left;
    padding: 0 40px;
    font-size: 16px;
  }
  .autograph {
    float: right;
  }
}
@media (max-width: 997px) {
  .content {
    padding: 30px;
  }
  .autograph {
    width: 200px;
  }
}
p {
  line-height: 35px;
  color: #333;
  margin: 0;
}
.autograph {
  width: 260px;
  margin: 10px 30px;
}

</style>
